import { useUpdatedRef } from '@sail/react';
import { noop, once } from '@sail/utils';
import { useMemo } from 'react';
import { UninitializedObservabilityProviderError } from '../internal/common/errors';
import logErrorInDev from '../internal/common/logErrorInDev';
import { useObservabilityApi } from '../internal/provider/ObservabilityApiProvider';
const logUninitializedErrorOnce = once(()=>{
    logErrorInDev(new UninitializedObservabilityProviderError('useAnalytics'));
});
// WeakMap to store analytics objects by provider instance
const providerAnalyticsMap = new WeakMap();
const defaultAnalytics = {
    action: noop,
    link: noop,
    modal: noop,
    track: noop,
    viewed: noop
};
/**
 * @see https://sail.stripe.me/apis/observability/useAnalytics
 */ export default function useAnalytics() {
    const api = useObservabilityApi();
    const apiRef = useUpdatedRef(api);
    return useMemo(()=>{
        // eslint-disable-next-line react-hooks/refs
        const currentApiValue = apiRef.current;
        // eslint-disable-next-line react-hooks/refs
        if (!currentApiValue) {
            logUninitializedErrorOnce();
            return defaultAnalytics;
        }
        // Check if we already have analytics for this provider
        let analytics = providerAnalyticsMap.get(currentApiValue);
        if (!analytics) {
            analytics = {
                action (...args) {
                    var _apiRef_current_analytics, _apiRef_current;
                    return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : (_apiRef_current_analytics = _apiRef_current.analytics) === null || _apiRef_current_analytics === void 0 ? void 0 : _apiRef_current_analytics.action(...args);
                },
                link (...args) {
                    var _apiRef_current_analytics, _apiRef_current;
                    return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : (_apiRef_current_analytics = _apiRef_current.analytics) === null || _apiRef_current_analytics === void 0 ? void 0 : _apiRef_current_analytics.link(...args);
                },
                modal (...args) {
                    var _apiRef_current_analytics, _apiRef_current;
                    return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : (_apiRef_current_analytics = _apiRef_current.analytics) === null || _apiRef_current_analytics === void 0 ? void 0 : _apiRef_current_analytics.modal(...args);
                },
                track (...args) {
                    var _apiRef_current_analytics, _apiRef_current;
                    return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : (_apiRef_current_analytics = _apiRef_current.analytics) === null || _apiRef_current_analytics === void 0 ? void 0 : _apiRef_current_analytics.track(...args);
                },
                viewed (...args) {
                    var _apiRef_current_analytics, _apiRef_current;
                    return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : (_apiRef_current_analytics = _apiRef_current.analytics) === null || _apiRef_current_analytics === void 0 ? void 0 : _apiRef_current_analytics.viewed(...args);
                }
            };
            // eslint-disable-next-line react-hooks/refs
            providerAnalyticsMap.set(currentApiValue, analytics);
        }
        return analytics;
    }, [
        apiRef
    ]);
}

//# sourceMappingURL=useAnalytics.js.map